import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlContainer, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-sm-label',
  templateUrl: './sm-label.component.html',
  styleUrls: ['./sm-label.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  providers: [
      {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => SmLabelComponent),
          multi: true
      }
  ]
})
export class SmLabelComponent implements OnInit {
  @Input() props: any;

  ngOnInit(): void {
  }

}
